module.exports = __webpack_public_path__ + "static/media/zoo-negara.c820c368.jpeg";